import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarSimpleLeftSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSidebarSimpleLeftSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM19 5H9V19H19V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarSimpleLeftSquare;
